import React, { Component } from "react";

import {
  OverlayTrigger,
  Popover,
} from "react-bootstrap";

const MAX_IMAGE_ERROR_RETRIES = 2;

class MyImage extends Component {
	constructor(props) {
		super(props);
        this.state = {
            tooltip: '',
            src: this.props.src,
            errorRetries: 0,
        };
        this.retryTimeoutId = null;
	}

    componentDidUpdate(prevProps) {
        if (prevProps.src !== this.props.src) {
            this.clearRetryTimeout();
            this.setState({ src: this.props.src, errorRetries: 0, tooltip: '' });
        }
    }

    componentWillUnmount() {
        this.clearRetryTimeout();
    }

    clearRetryTimeout = () => {
        if (this.retryTimeoutId !== null) {
            clearTimeout(this.retryTimeoutId);
            this.retryTimeoutId = null;
        }
    };

    toggleJpgExtension = (path) => {
        if (/\.jpg/.test(path)) {
            return path.replace(/\.jpg/, '.JPG');
        }
        if (/\.JPG/.test(path)) {
            return path.replace(/\.JPG/, '.jpg');
        }
        return path;
    };

    handleImageError = () => {
        const { errorRetries, src } = this.state;

        if (src && src.startsWith('data:')) {
            this.setState({ tooltip: 'Image Not Available' });
            return;
        }

        if (errorRetries >= MAX_IMAGE_ERROR_RETRIES) {
            this.setState({ tooltip: 'Image Not Available' });
            return;
        }

        const src_at_error = src;
        this.clearRetryTimeout();
        this.retryTimeoutId = setTimeout(() => {
            this.retryTimeoutId = null;

            if (this.props.src !== src_at_error) {
                return;
            }

            const toggled_path = this.toggleJpgExtension(src_at_error);
            const new_src = toggled_path !== src_at_error
                ? toggled_path
                : src_at_error + "?updated_at=" + Math.floor((Math.random() * 100) + 1);

            this.setState({
                src: new_src,
                errorRetries: errorRetries + 1,
            });
        }, 1000);
    };

	render() {
        const { className, style, height, width, alt } = this.props;
        const { tooltip, src } = this.state;

        if (!src) {
            return null;
        }

		return (
            <React.Fragment>
                {
                    tooltip
                        ?
                            <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{ tooltip } </Popover>}>
                                <img
                                    alt={alt}
                                    src={src}
                                    onError={this.handleImageError}
                                    className={className}
                                    style={style}
                                    height={height}
                                    width={width}
                                />
                            </OverlayTrigger>
                        :
                            <img
                                alt={alt}
                                src={src}
                                onError={this.handleImageError}
                                className={className}
                                style={style}
                                height={height}
                                width={width}
                            />
                }
            </React.Fragment>
        );
	}
}

export default MyImage;
